<template>
  <BaseSentimentPieChart
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
  />
</template>

<script>
import BaseSentimentPieChart from '@/components/cards/BaseSentimentPieChart';

export default {
  name: 'SentimentPieChart',
  components: {
    BaseSentimentPieChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
